export enum DrawerTypes {
  Form = 'Form',
  Component = 'Component',
}
